<script setup>
// PDF 다운로드 진행률 표시. pdfDownloader.js 의 onProgress 가 넘기는 값을 그대로 받는다.
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  progress: { type: Object, default: null }
});

// 남은 시간은 페이지 하나가 끝날 때만 새로 계산되므로, 그 사이에는 흐른 시간만큼 줄여서 보여준다.
const now = ref(Date.now());
let timer = null;
onMounted(() => {
  timer = setInterval(() => { now.value = Date.now(); }, 500);
});
onBeforeUnmount(() => {
  if (timer) clearInterval(timer);
});

const percent = computed(() => Math.max(0, Math.min(100, props.progress?.percent ?? 0)));

const isFinishing = computed(() => {
  const p = props.progress;
  return !!(p && p.total && p.completed >= p.total);
});

const statusText = computed(() => {
  const p = props.progress;
  if (!p || !p.total) return '준비 중';
  if (isFinishing.value) return p.message || '마무리 중';
  return `${p.current} / ${p.total} 페이지 처리 중`;
});

const remainingText = computed(() => {
  const p = props.progress;
  if (!p || !p.total || isFinishing.value) return '';
  if (p.remainingSeconds == null) return '남은 시간 계산 중';
  const passed = Math.floor((now.value - (p.updatedAt || now.value)) / 1000);
  return `약 ${Math.max(1, p.remainingSeconds - passed)}초 남음`;
});
</script>

<template>
  <div class="pdf-progress">
    <div class="bar">
      <div class="fill" :style="{ width: percent + '%' }"></div>
    </div>
    <p class="text">
      <span>{{ statusText }}</span>
      <span class="percent">{{ percent }}%</span>
      <span v-if="remainingText" class="remain">{{ remainingText }}</span>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.pdf-progress {
  width: 400px;
  margin: 12px auto 0;
  .bar {
    height: 8px;
    border-radius: 4px;
    background-color: #e5e7eb;
    overflow: hidden;
  }
  .fill {
    height: 100%;
    background-color: #247CFF;
    border-radius: 4px;
    transition: width .3s ease;
  }
  .text {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 6px;
    font-size: 14px;
    color: #4a4f63;
    .percent { font-weight: 700; color: #247CFF; }
    .remain { color: #6b7280; }
  }
}
</style>
